"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Consultation() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="4554" id="technologyconsultationcta" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[900px] w-[900px] max-w-[140%] rounded-lg" style={{
        background: "radial-gradient(circle at center, hsl(43 72% 52% / 0.15) 0%, hsl(43 72% 52% / 0.06) 30%, hsl(43 72% 52% / 0.02) 55%, transparent 75%)",
        filter: "blur(20px)"
      }} />
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "linear-gradient(var(--foreground) 1px, transparent 1px), linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "60px 60px"
    }} />

      <div className="relative mx-auto max-w-5xl px-6 py-24 sm:py-32 md:py-40 lg:py-[200px]">
        {}
        <div ref={eyebrowRef} className={`flex items-center justify-center gap-3 transition-all duration-700 ease-out ${eyebrowVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"}`}>
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75" style={{
            backgroundColor: "var(--primary)"
          }} />
            <span className="relative inline-flex h-2 w-2 rounded-lg" style={{
            backgroundColor: "var(--primary)"
          }} />
          </span>
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
            Expert Revenue Consulting / 2025
          </span>
        </div>

        {}
        <h2 ref={headlineRef} className={`mt-10 text-center font-serif font-light text-foreground transition-all duration-1000 ease-out ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
        fontSize: "clamp(3rem, 10vw, 7.5rem)",
        lineHeight: 0.95,
        letterSpacing: "-0.02em"
      }}>
          Maximize revenue
          <span style={{
          color: "var(--primary)"
        }}>.</span>
        </h2>

        {}
        <p ref={bodyRef} className={`mx-auto mt-8 max-w-2xl text-center text-base sm:text-lg leading-relaxed text-muted-foreground font-default transition-all duration-1000 delay-100 ease-out ${bodyVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          Sunil Singh provides data-driven OTA strategies to help your hotel reach its full potential.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 flex flex-col items-center justify-center gap-5 sm:flex-row sm:gap-8 transition-all duration-1000 delay-200 ease-out ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <Button asChild size="lg" className="group h-12 px-7 font-mono text-[12px] uppercase tracking-[0.18em] shadow-lg">
            <Link to="/ContactPage">
              <span>Book a Consultation</span>
              <ArrowRight className="size-4 transition-transform duration-300 ease-out group-hover:translate-x-1" />
            </Link>
          </Button>

          <Link to="/ServicesPage" className="group relative inline-flex items-center font-default text-sm text-foreground">
            <span className="relative pb-1">
              View Our Services
              <span aria-hidden="true" className="absolute bottom-0 left-0 h-px w-full origin-left scale-x-100 bg-foreground/40 transition-transform duration-300 ease-out group-hover:scale-x-0" />
              <span aria-hidden="true" className="absolute bottom-0 left-0 h-px w-full origin-right scale-x-0 transition-transform duration-300 ease-out delay-150 group-hover:origin-left group-hover:scale-x-100" style={{
              backgroundColor: "var(--primary)"
            }} />
            </span>
          </Link>
        </div>

        {}
        <div ref={footerRef} className={`mt-24 sm:mt-32 transition-all duration-1000 delay-300 ease-out ${footerVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"}`}>
          <div className="flex items-center gap-4 sm:gap-6">
            <Separator className="flex-1 bg-border/60" />
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground/70 whitespace-nowrap">
              HotelRevBaBa — Revenue Management Experts
            </span>
            <Separator className="flex-1 bg-border/60" />
          </div>
        </div>
      </div>
    </section>;
}